import clsx from 'clsx'
import useProductForm from 'hooks/useProductForm'
import useBundleGlobal from 'hooks/useBundleGlobal'
import ProductATC from 'snippets/product/product-atc/product-atc'
import ProductVariant from 'snippets/product/product-variant/product-variant'
import ProductLinked from 'snippets/product/product-linked/product-linked'
import ProductSubscription from 'snippets/product/product-subscription/product-subscription'
import ProductEarnPoints from 'snippets/product/product-earn-points/product-earn-points'
import ButtonBIS from 'snippets/button-atc/button-bis'

function ProductForm() {
  const {
    currentVariant,
    initProduct,
    updateCurrentVariant,
    sellingPlanId,
    setSellingPlanId,
    currentVariantPrice,
    setCurrentVariantPrice
  } = useProductForm()
  const { productBundles } = useBundleGlobal()
  const { available } = currentVariant
  const { title, options, variants, has_only_default_variant: hasOnlyDefaultVariant, tags } = initProduct
  const hasNoNotifyMeTag = (tags.length > 0 && tags.some((tag) => tag === 'no-notify-me')) || false
  const enableBackInStock = !available && !hasNoNotifyMeTag

  return (
    <div className={clsx(GM_STATE.product?.loyaltyEnable ? 'mt-4 lg:xs-h-max:mt-2.5' : 'mt-6')}>
      {GM_STATE.product?.loyaltyEnable && <ProductEarnPoints product={initProduct} />}
      <ProductLinked
        currentProductHandle={initProduct.handle}
        productIds={[initProduct.id, ...initProduct.metafields.linked.ids]}
      />
      <ProductVariant
        options={options}
        variants={variants}
        currentVariant={currentVariant}
        updateCurrentVariant={updateCurrentVariant}
        hasOnlyDefaultVariant={hasOnlyDefaultVariant}
      />
      <ProductSubscription
        currentVariant={currentVariant}
        planGroups={initProduct?.sellingPlanGroups}
        setSellingPlanId={setSellingPlanId}
        setCurrentVariantPrice={setCurrentVariantPrice}
        classWrap={!initProduct.metafields.linked.ids?.length ? 'border-t' : ''}
      />
      {initProduct.price !== 0 || initProduct?.sellingPlanGroups?.length ? (
        <div className="relative flex w-full">
          {initProduct?.sellingPlanGroups?.length ? (
            <div className="absolute left-0 top-0 z-3 block h-px w-full bg-neutral-900" />
          ) : null}

          {initProduct.price !== 0 &&
            (enableBackInStock ? (
              <ButtonBIS
                product={initProduct}
                currentVariant={currentVariant}
                buttonText={translate.product.notifyMeWhenAvailable}
                classButton="button-primary w-full"
              />
            ) : (
              <ProductATC
                title={title}
                productBundles={productBundles}
                buttonText={translate.general.addToCart}
                currentVariant={currentVariant}
                isEnabledInput={false}
                initProduct={initProduct}
                buttonClass={`button button-primary ${available ? 'text-left' : 'text-center'}`}
                updateCurrentVariant={updateCurrentVariant}
                currentVariantPrice={currentVariantPrice}
                sellingPlanId={sellingPlanId}
                classWrap="flex-1"
                showWishlistButton
                hiddenPrice
              />
            ))}
        </div>
      ) : null}
    </div>
  )
}

export default ProductForm
